<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Bioreq Documents</span>
    <div slot="buttons" class="text-right">
      <b-button variant="success" @click="$refs.addModal.openModal()"><i class="fas fa-plus"></i> Add Bioreq Document</b-button>
    </div>
    <b-tabs card no-fade>
      <b-tab title="Pending" active>
        <pending ref="pending"/>
      </b-tab>
      <b-tab title="Processed">
        <processed ref="processed"/>
      </b-tab>
    </b-tabs>

    <add-modal ref="addModal" />
  </page>
</template>

<script>
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import pending from './pending'
import processed from './processed'
import addModal from './addModal'

export default {
  components: {
    page,
    sidebar,
    pending,
    processed,
    addModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/bioreq/index.vue